"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plural_fr = exports.plural_en = exports.escape = void 0;
var escape = function () {
  var MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&#34;',
    "'": '&#39;'
  };
  var repl = function repl(c) {
    return MAP[c];
  };
  return function (s) {
    return s.replace(/[&<>'"]/g, repl);
  };
}();
exports.escape = escape;
var plural_en = function plural_en(value, s, p) {
  if (value == 1) return s;
  return p;
};
exports.plural_en = plural_en;
var plural_fr = function plural_fr(value, s, p) {
  if (value == 1 || value == 0) return s;
  return p;
};
exports.plural_fr = plural_fr;